import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { DevicePermission } from 'console/device/device_ts';
import { GraphsTabContent } from './content';
import { DefaultTabKey } from 'console/shared/content/tab/types';
export const graphs_tab_definition = {
    key: DefaultTabKey.graphs,
    title: 'Графики',
    iconclass: 'ui-icon-tab-stats',
    should_appear_depends_on: ['capabilities', 'access'],
    should_appear: (_device, _account, r_device, r_account) => {
        if (r_device == null) {
            return false;
        }
        if (!LegacyDevice.has_access(r_account.id, r_device, DevicePermission.view_history))
            return false;
        if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_gtw_reports))
            return true;
        if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_multiple_thermometers))
            return true;
        if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_ztc_state_packets))
            return true;
        if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_autoscan_packets))
            return true;
        return false;
    },
    render: GraphsTabContent,
};
